import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Event } from "../models/event";

@Injectable({
    providedIn: 'root'
})

export class EventService {
    constructor(private http: HttpClient) { }

    getEvents(params?) {
        return this.http.get<Event[]>(`${environment.API}events`, { params }).pipe();
    }

    getEventByID(params?) {
        return this.http.get<Event>(`${environment.API}events/${params.id}`).pipe();
    }

    createEvent(body) {
        return this.http.post<any>(`${environment.API}events`, body).pipe();
    }

    updateEvent(eventID: number, body) {
        return this.http.put<any>(`${environment.API}events/${eventID}`, body).pipe();
    }

    cancelEvent(eventID: number) {
        return this.http.post<any>(`${environment.API}events/${eventID}/cancel`, {}).pipe();
    }

    updateEventParticipant(eventID: number, body) {
        return this.http.post<any>(`${environment.API}events/${eventID}/participants`, body).pipe();
    }
}
